/**
 * Shown when VITE_CLERK_PUBLISHABLE_KEY isn't set — i.e. someone cloned the
 * repo and ran `npm run dev` without provisioning Clerk yet. Tells them
 * what to do. Engineering Principle #5: never silently fail.
 */

export default function NotConfiguredPage(): React.ReactElement {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 40,
        background: "#0D0F14",
        color: "#E6E6E6",
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}
    >
      <div style={{ maxWidth: 520 }}>
        <h1 style={{ margin: 0, fontSize: 24 }}>Almost there.</h1>
        <p style={{ marginTop: 16, color: "#A8AEC2", lineHeight: 1.6 }}>
          The dashboard isn't connected to its auth provider yet. Add{" "}
          <code style={inlineCode}>VITE_CLERK_PUBLISHABLE_KEY</code> to your{" "}
          <code style={inlineCode}>apps/web/.env.local</code> and refresh.
        </p>
        <p style={{ marginTop: 16, color: "#7C829A", fontSize: 13 }}>
          Get the key from{" "}
          <a href="https://dashboard.clerk.com" style={{ color: "#4ADE80" }}>
            dashboard.clerk.com
          </a>{" "}
          → your application → API keys.
        </p>
      </div>
    </div>
  );
}

const inlineCode: React.CSSProperties = {
  background: "#1F2435",
  padding: "2px 6px",
  borderRadius: 4,
  fontSize: 13,
  fontFamily: "ui-monospace, monospace",
};
